import { sortByLastUsed } from "@tvg/api/lastUsedDateTime";
import { PaymentTypeItem, PaymentTypeOption } from "@tvg/wallet/src/types";
import { isCardExpired } from "@tvg/wallet/src/utils";

export const filterAndSortAccountsOnFile = (
  accountsOnFile: PaymentTypeOption[],
  isMZMToggleOn: boolean = false
) =>
  accountsOnFile
    .filter(
      (method: PaymentTypeOption) =>
        method.paymentType !== "SLP" &&
        (isMZMToggleOn || method.paymentType !== "MZM")
    )
    .filter(
      (pm) => pm.withdrawalsAvailable && !isCardExpired(pm.expirationDate)
    )
    .filter((pm) => pm.paymentTypeAvailable)
    .sort((a, b) => sortByLastUsed(a.lastUsedDateTime, b.lastUsedDateTime));

export const getChkPmOption = (otherMethods: PaymentTypeItem[]) => {
  const chk = otherMethods.find((item) => item.paymentType === "CHK");

  if (!chk || chk.paymentTypeOptions.length === 0) return null;

  return chk.paymentTypeOptions[0];
};
